import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Play } from 'lucide-react';
import Watermark from './Watermark';

const PropertyGallery = ({ fotos, videos, titulo }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [currentMediaType, setCurrentMediaType] = useState('foto'); // 'foto' o 'video'

  const allMedia = [
    ...fotos.map(foto => ({ type: 'foto', src: foto })),
    ...videos.map(video => ({ type: 'video', src: video }))
  ];

  const openLightbox = (index, type) => {
    setSelectedIndex(index);
    setCurrentMediaType(type);
  };

  const closeLightbox = () => {
    setSelectedIndex(null);
  };

  const goToNext = () => {
    if (selectedIndex < allMedia.length - 1) {
      setSelectedIndex(selectedIndex + 1);
      setCurrentMediaType(allMedia[selectedIndex + 1].type);
    }
  };

  const goToPrevious = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
      setCurrentMediaType(allMedia[selectedIndex - 1].type);
    }
  };

  return (
    <div>
      {/* Grid de fotos */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {fotos.map((foto, index) => (
          <div
            key={`foto-${index}`}
            onClick={() => openLightbox(index, 'foto')}
            className="relative aspect-video rounded-lg overflow-hidden cursor-pointer group"
          >
            <img
              src={foto}
              alt={`${titulo} - Foto ${index + 1}`}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            />
            <Watermark />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
          </div>
        ))}

        {/* Videos */}
        {videos.map((video, index) => (
          <div
            key={`video-${index}`}
            onClick={() => openLightbox(fotos.length + index, 'video')}
            className="relative aspect-video rounded-lg overflow-hidden cursor-pointer group bg-gray-900"
          >
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-amber-500 rounded-full p-4 group-hover:bg-amber-600 transition-colors">
                <Play className="text-white" size={32} />
              </div>
            </div>
            <Watermark />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
              <p className="text-white text-sm font-medium">Video {index + 1}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center">
          {/* Botón cerrar */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-amber-400 transition-colors z-10"
          >
            <X size={36} />
          </button>

          {/* Navegación anterior */}
          {selectedIndex > 0 && (
            <button
              onClick={goToPrevious}
              className="absolute left-4 text-white hover:text-amber-400 transition-colors z-10"
            >
              <ChevronLeft size={48} />
            </button>
          )}

          {/* Navegación siguiente */}
          {selectedIndex < allMedia.length - 1 && (
            <button
              onClick={goToNext}
              className="absolute right-4 text-white hover:text-amber-400 transition-colors z-10"
            >
              <ChevronRight size={48} />
            </button>
          )}

          {/* Contenido */}
          <div className="max-w-6xl w-full mx-4">
            {allMedia[selectedIndex].type === 'foto' ? (
              <div className="relative">
                <img
                  src={allMedia[selectedIndex].src}
                  alt={`${titulo} - Vista ${selectedIndex + 1}`}
                  className="w-full h-auto max-h-[85vh] object-contain"
                />
                <div className="absolute bottom-4 right-4">
                  <Watermark />
                </div>
              </div>
            ) : (
              <div className="aspect-video">
                <iframe
                  src={allMedia[selectedIndex].src}
                  title={`${titulo} - Video`}
                  className="w-full h-full"
                  allowFullScreen
                />
              </div>
            )}

            {/* Contador */}
            <p className="text-white text-center mt-4">
              {selectedIndex + 1} / {allMedia.length}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PropertyGallery;
